import {getClientConfig} from 'ultra/configs/general';

import {post} from './http'; // get

const {api} = getClientConfig(window)
export function getConfirmData(confirm, partner, product, form) {
    let link = `${api}/partner/form/confirm/${partner}/${product}/${confirm}`;
    return post(link, form);
}

export function getWidgetData(type, partner, product, widget, form) {
    let link = `${api}/partner/widget/get/${type}/${partner}/${product}/${widget}`;
    return post(link, form);
}

export function setWidgetData(type, partner, product, widget, data) {
    let link = `${api}/partner/widget/set/${type}/${partner}/${product}/${widget}`;
    return post(link, data);
}
